import React, { useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DatePicker from "components/forms/date-picker";

import {
  TextField,
  Dialog,
  CircularProgress,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { ATTENDANCE_TYPE, getHolidays } from "lib/attendance";
import { DialogEditCategory } from "./style";
import moment from "moment";

const EditAttendance = ({
  employee,
  attendanceRecord,
  selectedDate,
  onCancel,
  onSave,
  saving,
  onDelete,
  deleting,
}) => {
  const [data, setData] = useState({
    employee_id: employee.id,
    employee_name: employee.name,
    date_from: selectedDate || attendanceRecord?.date || "",
    date_to: selectedDate || attendanceRecord?.date || "",
    type: attendanceRecord?.type || "",
    hour: attendanceRecord?.hour || 8,
  });

  const TYPES_FORCING_EIGHT = ["F", "D", "MA", "M"];

  const handleChange = (field, value) => {
    let newValue = value;

    if (field === "hour") {
      const numValue = parseFloat(value);

      if (numValue > 4) {
        newValue = 4;
      } else if (numValue < 1 || isNaN(numValue)) {
        newValue = 1;
      }
    }

    let newData = { ...data, [field]: newValue };

    if (field === "type") {
      const typesToForceEight = ["F", "D", "MA", "M"];
      if (typesToForceEight.includes(value)) {
        newData.hour = 8;
      } else {
        newData.hour = 4;
      }
    }

    setData(newData);
  };

  const handleGenerateAndSave = () => {
    const start = moment(data.date_from);
    const end = moment(data.date_to);
    const attendanceList = [];

    // Controllo validità date
    if (!start.isValid() || !end.isValid() || start.isAfter(end)) {
      alert("Controlla le date inserite.");
      return;
    }

    let holidays = getHolidays(start.year());
    if (start.year() !== end.year()) {
      holidays = [...holidays, ...getHolidays(end.year())];
    }

    let current = start.clone();

    while (current.isSameOrBefore(end)) {
      const dayStr = current.format("YYYY-MM-DD");
      const isWeekend = current.isoWeekday() >= 6;
      const isHoliday = holidays.includes(dayStr);

      if (!isWeekend && !isHoliday) {
        attendanceList.push({
          id: 0,
          date: current.format("YYYY-MM-DD"),
          type: data.type,
          hour: Number(data.hour),
          employee_id: data.employee_id,
          employee_name: data.employee_name,
        });
      }

      current.add(1, "days");
    }

    onSave(attendanceList);
  };
  const canDeleteSingleDay = Boolean(selectedDate && attendanceRecord);

  const handleDeleteSingleDay = () => {
    if (!window.confirm("Vuoi eliminare la presenza di questo giorno?")) {
      return;
    }

    onDelete([
      {
        id: 0,
        date: data.date_from,
        employee_id: data.employee_id,
        employee_name: data.employee_name,
      },
    ]);
  };

  const isHourDisabled = TYPES_FORCING_EIGHT.includes(data.type);

  return (
    <Dialog open={true} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>
        {`Gestione Presenze - ${employee.name}`}
        {selectedDate && ` (${moment(selectedDate).format("DD/MM/YYYY")})`}
      </DialogTitle>
      <DialogContent>
        <DialogEditCategory>
          {(saving || deleting) && <CircularProgress />}
          {!saving && !deleting && (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                paddingTop: "10px",
              }}
            >
              {!selectedDate && (
                <div style={{ display: "flex", gap: "20px" }}>
                  <DatePicker
                    format={"dd/MM/yyyy"}
                    label="Dal"
                    margin="none"
                    validators={["required"]}
                    onChange={(e) => handleChange("date_from", e)}
                  />

                  <DatePicker
                    format={"dd/MM/yyyy"}
                    label="Al"
                    margin="none"
                    validators={["required"]}
                    onChange={(e) => handleChange("date_to", e)}
                  />
                </div>
              )}
              <FormControl fullWidth>
                <InputLabel id="type-label">Tipo Assenza</InputLabel>
                <Select
                  labelId="type-label"
                  value={data.type}
                  label="Tipo Assenza"
                  onChange={(e) => handleChange("type", e.target.value)}
                >
                  {ATTENDANCE_TYPE.map((item) => (
                    <MenuItem key={item.type} value={item.type}>
                      {item.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                label="Ore"
                type="number"
                value={data.hour}
                fullWidth
                slotProps={{
                  input: {
                    min: 1,
                    max: 4,
                  },
                }}
                disabled={isHourDisabled}
                onChange={(e) => handleChange("hour", e.target.value)}
              />
            </div>
          )}
        </DialogEditCategory>
      </DialogContent>
      <DialogActions>
        {canDeleteSingleDay && (
          <Button
            color="error"
            variant="contained"
            onClick={handleDeleteSingleDay}
            disabled={saving || deleting}
            sx={{ marginRight: "auto" }}
          >
            Elimina
          </Button>
        )}
        <Button onClick={onCancel}>Annulla</Button>
        <Button
          variant="contained"
          type="button"
          onClick={handleGenerateAndSave}
          disabled={!data.type || !data.date_from || !data.date_to || deleting}
        >
          Salva
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditAttendance;